module.exports = __webpack_public_path__ + "img/logopoliticasdeprivacidad@2x.98b34c74.png";